import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import Sortable      from 'react-sortablejs' ;
import ContentsModal from 'contents_modal';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class ProgressGroupModal extends React.Component {
  submit(mode) {
    let data = this.props.data;
    
    let name = this.name.value;
    let help = this.help.value;
    if( name == '' ){
      alert('グループ名は必ず入力してください');
      return;
    }
    
    Utils.request.bind(this)('/api/project/workflow/'+ mode +'_group', { project_id: this.props.project_id, name: name, help: help, group_id: data.group_id, progress: data.progress, order_no: data.order_no, parent: data.parent },
      function(res){
        this.set_data.bind(this)(res.body.data);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  delete() {
    let chk = confirm('グループを削除してもよろしいですか？');
    if( chk == false ) return;
    
    let data = this.props.data;
    
    Utils.request.bind(this)('/api/project/workflow/delete_group', { project_id: this.props.project_id, group_id: data.group_id },
      function(res){
        this.set_data.bind(this)(res.body.data);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  set_data(workflow) {
    //let workflow = Object.assign({}, this.props.base.workflow);
    //workflow.groups = update;
    this.props.base.event.updateData('workflow', workflow);
    
    this.props.close_ev.bind(this)(false);
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    if( data == undefined ) data = {};
    
    return (
      <div className="group-edit-modal">
        <ContentsModal
          view      = {this.props.view}
          width     = {350}
          height    = {250}
          close_ev  = {this.props.close_ev.bind(this, false)}
          html      = {
            <div className="modal-item">
              {(data.group_id != undefined)
                ? <h3>グループの編集</h3>
                : <h3>グループの作成</h3>
              }
              
              <h5>グループ名 <span className="hissu">必須</span></h5>
              <input className="text" type="text" ref={(input) => { this.name = input }} placeholder="グループ名" defaultValue={data.name} />
              
              
              <h5>グループの説明</h5>
              <input className="text" type="text" ref={(input) => { this.help = input }} placeholder="グループの説明" defaultValue={data.help} />
              
              {(data.group_id != undefined)
                ? <div className="double">
                    <div className="button" onClick={this.submit.bind(this, 'update')}>登録</div>
                    {(this.props.list_count > 0)
                      ? <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>インフルエンサーがリストに入っている場合は削除できません。</Tooltip>}>
                          <div className="button off">削除</div>
  	                    </OverlayTrigger>
                      : <div className="button no" onClick={this.delete.bind(this)}>削除</div>
                    }
                  </div>
                : <div className="single">
                    <div className="button" onClick={this.submit.bind(this, 'insert')}>登録</div>
                  </div>
              }
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProgressGroupModal;